import { render, staticRenderFns } from "./ModalPic.vue?vue&type=template&id=b18b5802&scoped=true&"
import script from "./ModalPic.vue?vue&type=script&lang=js&"
export * from "./ModalPic.vue?vue&type=script&lang=js&"
import style0 from "./ModalPic.vue?vue&type=style&index=0&id=b18b5802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18b5802",
  null
  
)

export default component.exports